'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var white = exports.white = '#ffffff';
var red = exports.red = '#FF3600';
var grey = exports.grey = '#E9EDEF';
var darkGrey = exports.darkGrey = '#8EA1AC';
var black = exports.black = '#263238';
var blue = exports.blue = '#04A9F4';
var green = exports.green = '#50CE56';
var teal = exports.teal = '#1EF193';
var purple = exports.purple = '#9219F1';
var pink = exports.pink = '#FF2DB0';
var orange = exports.orange = '#FEB94A';
var yellow = exports.yellow = '#FFCE06'; // export const yellow = '#FFE071';